import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const Container = styled.div`
  width: 100%;
  min-height: 280px;
  border-radius: 8px;
  border: 1px solid var(--neutralDark500);
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: ease all 0.2s;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border: solid 1px var(--lightBlue);
    }
  }

  @media (max-width: 768px) {
    max-width: 230px;
  }
`;

export const CourseBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 768px) {
    padding: 0 8px;
    margin-bottom: 8px;
  }
`;

export const CourseImageContainer = styled.div`
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  height: 193px;
  flex: 0 0 auto;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  @media (max-width: 768px) {
    padding: 8px;
    height: auto;

    img {
      border-radius: 8px;
      max-height: 140px;
      margin-bottom: 16px;
    }
  }
`;

export const CourseUpperContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const CourseCategory = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 20px;
  color: var(--lightBlue);
`;

export const BookmarkButton = styled.div`
  border: none;
  cursor: pointer;
  outline: none;
  padding: 6px;
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
  transition: ease all 0.2s;

  &.added-to-list {
    background-color: var(--lightBlue);
    color: white;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: var(--purple);
      svg path {
        color: white;
      }
    }
  }
`;

export const CourseLowerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CourseTitle = styled.div`
  color: #ffffff;
  font-size: 2rem;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const CourseAuthor = styled.div`
  color: var(--neutralLight40);
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 15px;
  margin-top: auto;
  letter-spacing: 1.5px;
  svg {
    margin-right: 10px;
    fill: var(--neutralDark500);
  }
`;

export const CourseFooter = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  line-height: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    letter-spacing: 1.5px;
  }
`;

export const CourseTime = styled.div`
  color: var(--neutralLight40);
  display: flex;
  align-items: center;
  font-size: 1.4rem;

  svg {
    margin-right: 10px;
    fill: var(--neutralDark500);
  }
`;

export const CourseLikes = styled.div`
  color: var(--neutralLight40);
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid rgba(80, 95, 121, 0.2);

  svg {
    margin-right: 10px;
    fill: var(--neutralDark500);
  }

  @media (max-width: 768px) {
    border: 0;
    margin-left: 0;
    padding-left: 0;
    margin-top: 8px;
  }
`;

export const CardTag = styled.span`
  position: absolute;
  display: flex;
  top: 15px;
  left: 15px;
  background-color: var(--purple);
  color: white;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 15px;
  border-radius: 30px;
  padding: 5px 12px;

  .sun-icon {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    top: 100px;
    width: 32px;
    height: 32px;

    .sun-icon {
      margin-right: 0;
      margin-left: -4px;
      width: 16px;
    }
  }
`;
